export const version = "solidity/5.5.0";
//# sourceMappingURL=_version.js.map